import { Dayjs } from "dayjs";

export interface Announcement {
    id: ID;
    actions?: AnnouncementAction[];
    createdBy: { id: ID };
    description: string;
    enabled: boolean;
    end: Dayjs;
    features: string[];
    pluginIds: ID[];
    roles: string[];
    start: Dayjs;
    createdAt: Dayjs;
    subscriptionPlanPackages: string[];
    title: string;
    photo?: { id: ID; src: string; type: string };
    types: AnnouncementType[];
}

export interface AnnouncementAction {
    id: ID;
    destination: AnnouncementActionDestination;
    label: string;
    sequence: number;
    type: AnnouncementActionType;
    url: string;
}

export enum AnnouncementActionDestination {
    IFRAME = "iframe",
    NEWTAB = "newTab",
    SAMETAB = "sameTab",
}

export enum AnnouncementActionType {
    ANCHOR = "anchor",
    BUTTON = "button",
}

export enum AnnouncementType {
    NOTICE = "notice",
    BANNER = "banner",
}

export interface AnnouncementFeedback {
    id: ID;
    announcement: { id: ID };
    createdAt: Dayjs;
    createdBy: { id: ID };
    email: string;
    name: string;
    roles: string[];
    seller: { id: ID };
    text: string;
    type: string;
}
